import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { textFieldSx } from './formStyles';

interface FormSelectOption {
  value: string | number;
  label: string;
}

interface FormSelectProps extends Omit<TextFieldProps, 'select' | 'error' | 'helperText' | 'onChange'> {
  hint?: string;
  error?: string;
  helperText?: React.ReactNode;
  options?: FormSelectOption[];
  placeholder?: string;
  children?: React.ReactNode;
  onChange?: React.ChangeEventHandler<HTMLSelectElement>;
}

export const FormSelect: React.FC<FormSelectProps> = ({
  label,
  hint,
  error,
  helperText,
  options,
  placeholder,
  id,
  required,
  children,
  sx,
  InputLabelProps,
  SelectProps,
  onChange,
  ...selectProps
}) => (
  <TextField
    select
    id={id}
    label={label}
    required={required}
    variant="outlined"
    fullWidth
    size="small"
    error={Boolean(error)}
    helperText={error || helperText || hint}
    sx={[textFieldSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    InputLabelProps={{ shrink: true, ...InputLabelProps }}
    SelectProps={{ native: true, ...SelectProps }}
    onChange={onChange as TextFieldProps['onChange']}
    {...selectProps}
  >
    {placeholder && (
      <option value="" disabled={required}>
        {placeholder}
      </option>
    )}
    {options
      ? options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))
      : children}
  </TextField>
);
